var map = {
	"./circle-checked.svg": "./src/assets/image/brb-checkbox/circle-checked.svg",
	"./circle-unchecked.svg": "./src/assets/image/brb-checkbox/circle-unchecked.svg",
	"./default-checked.png": "./src/assets/image/brb-checkbox/default-checked.png",
	"./default-unchecked.png": "./src/assets/image/brb-checkbox/default-unchecked.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/brb-checkbox sync recursive ^\\.\\/.*$";